exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".legend{position:absolute;right:20px;top:20px}.legend,.legend__tooltip{cursor:help}.legend__tooltip .tooltip-inner{max-width:400px;text-align:left;padding:15px}.legend__tooltip .tooltip-inner ul{margin:0}.legend__tooltip .tooltip-inner li:not(:last-of-type){margin-bottom:10px}", ""]);

// exports
